
import { useContext } from "react";
import "./style/loading.css";
import { AppMainContext } from "../context/AppMainContext";

export default function Loading() {
    const {loadingData} = useContext(AppMainContext);
    return ( 
        <div className="spinnerContainer">
            <div className="spinner"></div>
            <div className="loader">
                <p className="spinnerP">{loadingData.header}</p>
                <div className="words">
                <span className="word">{loadingData.data[0]}</span>
                <span className="word">{loadingData.data[1]}</span>
                <span className="word">{loadingData.data[2]}</span>
                <span className="word">{loadingData.data[3]}</span>
                <span className="word">{loadingData.data[4]}</span>
                </div>
            </div>
        </div>
    )
}


